// The superloci API doesnt use standard date formats, instead each video has a day in the form of
// "11th May 2018" and then timestmaps in a format like "08:28"
// This module decodes these into javascript dates.
// chrome ingested these quite easily, but there are a few hacks to make it work on safari/FF.

const monthIndexMap = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
    // Short Names
    Jan: 1,
    Feb: 2,
    Mar: 3,
    Apr: 4,
    May: 5,
    Jun: 6,
    Jul: 7,
    Aug: 8,
    Sep: 9,
    Oct: 10,
    Nov: 11,
    Dec: 12
}

export default (dateRaw, timestamp) => {

    // "11th May 2018" -> "11 May 2018"
    const dateWithoutSuffix = dateRaw
        .replace("th ", " ")
        .replace("st ", " ")
        .replace("rd ", " ");
    const split = dateWithoutSuffix.split(" ");
    let [date, monthStr, year] = split;
    let monthNum = monthIndexMap[monthStr];
    if (!monthNum) {
        console.error("Unrecognised month " + monthStr);
    }

    // Very bad date
    if (split.length < 3) {
        date = 1;
        year = 2018;
        monthNum = 1;
    }


    let [hours, minutes, seconds] = timestamp.split(":");

    let milliseconds = 0;
    if (seconds.includes(".")) {
        const secSplit = seconds.split(".");
        seconds = secSplit[0];
        milliseconds = parseFloat("0." + secSplit[1]) * 1000;
    }

    return new Date(year, monthNum, date, hours, minutes, seconds, milliseconds);
}


// WEBPACK FOOTER //
// ./src/modules/date-from-api-format.js